<template>
  <el-drawer
    :visible.sync="dialogVisible"
    size="40%"
    :before-close="handleClose"
    v-loading="loading"
    append-to-body
    :modal="false"
  >
    <div
      class="row text-black"
      v-if="indication"
    >
      <div class="text-center">
        <div class="text-2xl font-bold">
          {{ indication.indication_order.name }}
        </div>
      </div>

      <div class="text-center text-xl font-bold my-2">
        {{ indication.name }}
      </div>
      <div class="flex justify-end">
        <svg
          class="code w-40 height-60"
          id="barcode"
        ></svg>
      </div>
      <div class="row">
        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Họ tên</div>
          <div class="fs-14 fw-700 ml-2">{{ person && person.name ? person.name : 'N/A' }}</div>
        </div>
        <div class="col-md-6 flex fs-14 fw-400 txt-grey-900">
          <div>Tuổi: {{ person && person.age ? person.age : 'N/A' }}</div>
          <div class="ml-3"> Giới tính: {{ person && getGender() ? getGender() : 'N/A' }}</div>
        </div>
        <div class="flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Địa chỉ</div>
          <div class="fs-14 fw-700 ml-2">{{ person && person.address ? person.address : 'N/A' }}</div>
        </div>
        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">BHXH</div>
          <div class="fs-14 fw-700 ml-2">{{ person && person.insurance_number ? person.insurance_number : 'N/A' }}</div>
        </div>
        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Ngày hết hạn</div>
          <div class="fs-14 fw-700 ml-2">{{ person && person.insurance_expire ? formatDate(person.insurance_expire) : 'N/A' }}</div>
        </div>
        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Phòng</div>
          <div class="fs-14 fw-700 ml-2">{{ mr_master && mr_master.admission_room ? mr_master.admission_room : 'N/A'}}</div>
        </div>
        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Giường</div>
          <div class="fs-14 fw-700 ml-2">{{ mr_master && mr_master.admission_bed ? mr_master.admission_bed : 'N/A' }}</div>
        </div>

        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Ngày chỉ định</div>
          <div class="fs-14 fw-700 ml-2">
            {{
      indication.indication_order &&
      formatDMY(indication.indication_order.ind_date) ? formatDMY(indication.indication_order.ind_date) : 'N/A'
    }}
          </div>
        </div>
        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Bác sĩ chỉ định</div>
          <div class="fs-14 fw-700 ml-2">
            {{
      indication.indication_order &&
      indication.indication_order.user &&
      indication.indication_order.user.name ? indication.indication_order.user.name : 'N/A'
    }}
          </div>
        </div>
        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Nơi thực hiện</div>
          <div class="fs-14 fw-700 ml-2">
            {{ getDataDemo(indication.target_id)  ? getDataDemo(indication.target_id) : 'N/A'}}
          </div>
        </div>
        <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Ngày đến hạn</div>
          <div class="fs-14 fw-700 ml-2">{{ formatDate(indication.due_date) ? formatDate(indication.due_date) : 'N/A' }}</div>
        </div>
        <!-- <div class="col-md-6 flex">
  <p class="fs-14 fw-400 txt-grey-900">Người thực hiện</p>
  <p class="fs-14 fw-700 ml-2"></p>
</div> -->

        <div class="flex">
          <div class="fs-14 fw-400 txt-grey-900 mb-0 w-28">Chẩn đoán</div>
          <div class="fs-14 fw-700 ml-2">{{ mr_master && mr_master.disease_main_name ? mr_master.disease_main_name : 'N/A' }}</div>
        </div>
      </div>
      <div v-if="resulting">
        <div
          class="p-2"
          :class="show_highlight_result ? 'box-shadow-h' : '' "
        >
          <div class="font-bold text-base my-2 flex items-center">
            Tải kết quả
            <div class="ml-3">
              <div
                @click="modalUploadFile(true)"
                class="
                    flex
                    justify-center
                    items-center
                    h-full
                    rounded-xl
                    text-3xl text-gray-600
                    cursor-pointer
                  "
              >
                <i class="el-icon-upload"></i>
              </div>
            </div>
            <input
              type="file"
              @change="onSelectedFile($event)"
              class="d-none"
              ref="inputFile"
              multiple
            />
          </div>
          <div class="mb-2">
            <div
              class="mb-1"
              v-for="(file, index) in files"
              :key="index + 'file'"
            >
              <div class="
                    h-full
                    rounded-xl
                    p-2
                  ">
                <div class="row">
                  <div
                    class="wrap col-md-8 cursor-pointer"
                    @click="downloadFile(file.file_name)"
                  >
                    <span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_24814_125783)">
                          <path
                            d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                            fill="#0263D1"
                          />
                          <path
                            opacity="0.302"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M14.1675 0V7.0337H20.9747L14.1675 0Z"
                            fill="white"
                          />
                          <path
                            d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                            fill="white"
                          />
                          <path
                            d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z"
                            fill="white"
                          />
                          <path
                            d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                            fill="white"
                          />
                          <path
                            d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_24814_125783">
                            <rect
                              width="24"
                              height="24"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    {{ file.name }}
                  </div>
                  <div class="wrap col-md-4">
                    <span>{{ file.created_by && file.created_by.name }}</span>
                    <span class="ml-3">{{ formatDMY(file.created_at) }}</span>
                    <!-- delete link -->
                    <span
                      v-if="!isResult"
                      class="cursor-pointer ml-3"
                      @click="deleteFile(file.id, index)"
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.7529 4.69091C12.5329 4.47091 10.2996 4.35757 8.07293 4.35757C6.75293 4.35757 5.43293 4.42424 4.11293 4.55757L2.75293 4.69091"
                          stroke="#8D959C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6.41943 4.01757L6.5661 3.14423C6.67277 2.5109 6.75277 2.03757 7.87943 2.03757H9.6261C10.7528 2.03757 10.8394 2.53757 10.9394 3.1509L11.0861 4.01757"
                          stroke="#8D959C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.3194 6.79758L12.886 13.5109C12.8127 14.5576 12.7527 15.3709 10.8927 15.3709H6.6127C4.7527 15.3709 4.6927 14.5576 4.61937 13.5109L4.18604 6.79758"
                          stroke="#8D959C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.63965 11.7042H9.85965"
                          stroke="#8D959C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.08643 9.03757H10.4198"
                          stroke="#8D959C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <!-- delete link -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="font-bold text-base my-1 cursor-pointer">
              <span
                @click="addLink"
                class="font-normal fs-14 py-2 d-flex align-items-center"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="mr-1"
                >
                  <path
                    d="M8.61735 1.5267C4.94402 1.5267 1.95068 4.52004 1.95068 8.19337C1.95068 11.8667 4.94402 14.86 8.61735 14.86C12.2907 14.86 15.284 11.8667 15.284 8.19337C15.284 4.52004 12.2907 1.5267 8.61735 1.5267ZM11.284 8.69337H9.11735V10.86C9.11735 11.1334 8.89068 11.36 8.61735 11.36C8.34402 11.36 8.11735 11.1334 8.11735 10.86V8.69337H5.95068C5.67735 8.69337 5.45068 8.4667 5.45068 8.19337C5.45068 7.92004 5.67735 7.69337 5.95068 7.69337H8.11735V5.5267C8.11735 5.25337 8.34402 5.0267 8.61735 5.0267C8.89068 5.0267 9.11735 5.25337 9.11735 5.5267V7.69337H11.284C11.5574 7.69337 11.784 7.92004 11.784 8.19337C11.784 8.4667 11.5574 8.69337 11.284 8.69337Z"
                    fill="#808080"
                  />
                </svg>
                Thêm link
              </span>
            </div>
            <div
              class="mb-2 row"
              v-for="(link, index) in links"
              :key="'link' + index"
            >
              <div class="text-base col-md-8 pl-3">
                <span
                  class="cursor-pointer underline text-primary"
                  @click="openLink(link)"
                >
                  <span>
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.66672 11.9601L5.48672 13.1068C5.1773 13.4162 4.75764 13.5901 4.32005 13.5901C3.88247 13.5901 3.46281 13.4162 3.15339 13.1068C2.84397 12.7974 2.67014 12.3777 2.67014 11.9401C2.67014 11.5026 2.84397 11.0829 3.15339 10.7735L6.18005 7.74014C6.47713 7.4421 6.8774 7.26966 7.29806 7.25849C7.71873 7.24732 8.12758 7.39828 8.44005 7.68014L8.52005 7.74681C8.64647 7.87057 8.81688 7.93905 8.99379 7.93718C9.1707 7.9353 9.33962 7.86323 9.46339 7.73681C9.58716 7.61039 9.65563 7.43998 9.65376 7.26307C9.65188 7.08616 9.57981 6.91724 9.45339 6.79347C9.41576 6.74482 9.37571 6.6981 9.33339 6.65347C8.76429 6.15835 8.02828 5.89804 7.27443 5.92527C6.52059 5.9525 5.80528 6.26524 5.27339 6.80014L2.20672 9.83347C1.68562 10.4007 1.4038 11.1473 1.4201 11.9173C1.43641 12.6874 1.74957 13.4214 2.29421 13.966C2.83884 14.5106 3.57283 14.8238 4.34289 14.8401C5.11294 14.8564 5.85952 14.5746 6.42672 14.0535L7.58005 12.9268C7.69393 12.8026 7.75653 12.6398 7.75526 12.4713C7.75399 12.3028 7.68894 12.141 7.57319 12.0185C7.45745 11.896 7.29961 11.8219 7.13143 11.811C6.96325 11.8002 6.79721 11.8535 6.66672 11.9601ZM13.7934 2.46681C13.2326 1.90948 12.474 1.59666 11.6834 1.59666C10.8927 1.59666 10.1342 1.90948 9.57339 2.46681L8.42005 3.59347C8.30618 3.71771 8.24358 3.88046 8.24485 4.04898C8.24612 4.21751 8.31117 4.3793 8.42691 4.5018C8.54265 4.6243 8.7005 4.69841 8.86868 4.70924C9.03686 4.72006 9.2029 4.66679 9.33339 4.56014L10.4867 3.41347C10.7961 3.10405 11.2158 2.93022 11.6534 2.93022C12.091 2.93022 12.5106 3.10405 12.8201 3.41347C13.1295 3.72289 13.3033 4.14255 13.3033 4.58014C13.3033 5.01772 13.1295 5.43739 12.8201 5.74681L9.79339 8.78014C9.49631 9.07818 9.09604 9.25062 8.67538 9.26179C8.25472 9.27296 7.84586 9.122 7.53339 8.84014L7.45339 8.77347C7.32697 8.6497 7.15656 8.58123 6.97965 8.5831C6.80274 8.58498 6.63382 8.65705 6.51005 8.78347C6.38629 8.90989 6.31781 9.0803 6.31968 9.25721C6.32156 9.43412 6.39363 9.60304 6.52005 9.72681C6.56848 9.77633 6.61967 9.82307 6.67339 9.86681C7.24317 10.3604 7.97887 10.6198 8.73225 10.5926C9.48564 10.5653 10.2007 10.2536 10.7334 9.72014L13.7667 6.68681C14.3276 6.12952 14.6452 5.37296 14.6502 4.5823C14.6552 3.79165 14.3472 3.03113 13.7934 2.46681Z"
                        fill="#6E7883"
                      />
                    </svg>
                  </span>
                  <span class="ml-2 pl-1">{{ link.name }}</span>
                </span>
              </div>
              <div class="
                  col-md-4
                ">
                <span>{{ link.created_by && link.created_by.name }}</span>
                <span class="ml-3">{{ formatDMY(link.created_at) }}</span>
                <!-- delete link -->
                <span
                  v-if="!isResult"
                  class="cursor-pointer ml-3"
                  @click="deleteLink(link.id, index)"
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.7529 4.69091C12.5329 4.47091 10.2996 4.35757 8.07293 4.35757C6.75293 4.35757 5.43293 4.42424 4.11293 4.55757L2.75293 4.69091"
                      stroke="#8D959C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.41943 4.01757L6.5661 3.14423C6.67277 2.5109 6.75277 2.03757 7.87943 2.03757H9.6261C10.7528 2.03757 10.8394 2.53757 10.9394 3.1509L11.0861 4.01757"
                      stroke="#8D959C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.3194 6.79758L12.886 13.5109C12.8127 14.5576 12.7527 15.3709 10.8927 15.3709H6.6127C4.7527 15.3709 4.6927 14.5576 4.61937 13.5109L4.18604 6.79758"
                      stroke="#8D959C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.63965 11.7042H9.85965"
                      stroke="#8D959C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.08643 9.03757H10.4198"
                      stroke="#8D959C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <!-- delete link -->
              </div>
            </div>
            <div
              class="mb-3"
              v-if="formLink"
            >
              <div class="flex justify-between items-center mb-2">
                <div class="w-20">Tên Link</div>
                <el-input v-model="formLink.name"></el-input>
              </div>
              <div class="flex justify-between items-center mb-2">
                <div class="w-20">Đường dẫn</div>
                <el-input v-model="formLink.url"></el-input>
              </div>
              <div class="flex justify-end space-x-3">
                <el-button @click="closeAddLink">Hủy</el-button>
                <el-button
                  type="primary"
                  @click="submitLink"
                >Lưu Link</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3 px-2">
          <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
            <div class="font-bold text-base">
              Kết luận
              <span
                class="
                m-2
                font-normal
                text-sm
                cursor-pointer
                hover:bg-gray-100
                py-2
                px-3
                rounded-md
              "
                @click="addConclusion"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.61735 1.5267C4.94402 1.5267 1.95068 4.52004 1.95068 8.19337C1.95068 11.8667 4.94402 14.86 8.61735 14.86C12.2907 14.86 15.284 11.8667 15.284 8.19337C15.284 4.52004 12.2907 1.5267 8.61735 1.5267ZM11.284 8.69337H9.11735V10.86C9.11735 11.1334 8.89068 11.36 8.61735 11.36C8.34402 11.36 8.11735 11.1334 8.11735 10.86V8.69337H5.95068C5.67735 8.69337 5.45068 8.4667 5.45068 8.19337C5.45068 7.92004 5.67735 7.69337 5.95068 7.69337H8.11735V5.5267C8.11735 5.25337 8.34402 5.0267 8.61735 5.0267C8.89068 5.0267 9.11735 5.25337 9.11735 5.5267V7.69337H11.284C11.5574 7.69337 11.784 7.92004 11.784 8.19337C11.784 8.4667 11.5574 8.69337 11.284 8.69337Z"
                    fill="#808080"
                  />
                </svg>
                Thêm kết luận
              </span>
            </div>
            <el-button
              type="primary"
              class="bg-pri"
              @click="sendIndicationToPatient"
              :disabled="sending"
            >
              <span v-if="!sending">Gửi KQ cho Bệnh nhân</span>
              <span
                v-else
                class="spinner-border mx-5"
                role="status"
                style="width: 1.1rem; height: 1.1rem;"
              >
                <span class="sr-only">Loading...</span>
              </span>
            </el-button>
          </div>
          <div v-if="conclusions">
            <div
              class="mb-2 ml-2"
              v-for="(conclusion, index) in conclusions"
              :key="'conclusion' + index"
            >
              <div class="text-base">{{ conclusion.conclusion }}</div>
              <div class="
                  flex
                  fs-14
                  font-bold
                  text-gray-500
                  justify-between
                  items-center
                ">
                <div class="flex">
                  <div>{{ conclusion.user && conclusion.user.name }}</div>
                  <div class="ml-3">{{ formatDMY(conclusion.updated_at) }}</div>
                </div>
                <div class="ml-6 space-x-3 flex">
                  <!-- delete conclusion -->
                  <div
                    v-if="!isResult"
                    class="cursor-not-allowed"
                    @click="deleteConclusion(index)"
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.7529 4.69091C12.5329 4.47091 10.2996 4.35757 8.07293 4.35757C6.75293 4.35757 5.43293 4.42424 4.11293 4.55757L2.75293 4.69091"
                        stroke="#8D959C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.41943 4.01757L6.5661 3.14423C6.67277 2.5109 6.75277 2.03757 7.87943 2.03757H9.6261C10.7528 2.03757 10.8394 2.53757 10.9394 3.1509L11.0861 4.01757"
                        stroke="#8D959C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.3194 6.79758L12.886 13.5109C12.8127 14.5576 12.7527 15.3709 10.8927 15.3709H6.6127C4.7527 15.3709 4.6927 14.5576 4.61937 13.5109L4.18604 6.79758"
                        stroke="#8D959C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.63965 11.7042H9.85965"
                        stroke="#8D959C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.08643 9.03757H10.4198"
                        stroke="#8D959C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <!-- delete conclusion -->
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex justify-between items-center"
            v-if="formConclusion"
          >
            <el-input
              type="textarea"
              v-model="formConclusion.conclusion"
              placeholder="Nhập kết luận"
            >
            </el-input>
            <el-button
              class="ml-2 text-primary btn-icon"
              @click="submitConclusion"
            >
              <i class="el-icon-s-promotion"></i>
            </el-button>
          </div>
        </div>

        <div class="px-2">
          <div class="font-bold text-base my-2">
            <span v-if="indication.status">Nhận xét</span>
            <span class="mx-3 cursor-not-allowed">
              <el-button
                type="primary"
                class="bg-pri"
                @click="viewDetailResult"
              >Chi tiết Kết quả</el-button>
            </span>
          </div>
          <div
            class="mb-3"
            v-if="indication.status"
          >
            <IndicationComments :indication_id="indicationId" />
          </div>
        </div>
      </div>
      <div
        v-else
        class="my-5"
      >
        <div class="font-bold text-base">Trả Kết quả theo hình thức</div>
        <div class="flex justify-center items-center space-x-5">
          <el-button
            type="primary"
            class="bg-pri"
            @click="viewDetailResult"
          >Nhập thủ công</el-button>
          <el-button
            type="primary"
            class="bg-pri"
            @click="changeResulting"
          >Tải lên tệp hoặc URL</el-button>
        </div>
      </div>
    </div>

    <!-- Upload file -->
    <div
      class="modal fade"
      id="modalUploadFile"
      tabindex="-1"
      aria-labelledby="modalUploadTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 bg-white mt-3 mb-0">
            <h5 class="ml-4 fs-18 fw-700 txt-black">Chọn tệp</h5>
            <img
              src="../../../../../public/assets/images/icon/close-gray.svg"
              height="25px"
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div
              class="upload-btn mb-3"
              @click="uploadDocs"
            >
              <img
                class="mr-1"
                src="../../../../../public/assets/images/icon/u_upload.svg"
              />
              <span class="fs-14 txt-pri">Chọn file</span>
            </div>
            <div
              class="mb-3"
              v-for="(doc, i) in nameFiles"
              :key="i + 'slt_file'"
            >
              <div class="d-flex w-100 justify-content-between align-items-center">
                <el-input
                  v-model="doc.description"
                  class="fs-14 fw-600 mb-0 max-line-1 w-265px"
                />
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="cursor-pointer"
                  @click="deleteSltDoct(i)"
                >
                  <path
                    d="M6.00012 18.4998L17.9999 6.5"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.9999 18.4998L6.00012 6.5"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center mb-2">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
              @click="onUpload"
              :disabled="!selected_docs || !selected_docs.length"
            >
              Tải lên
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Detail Result -->
    <ModalDetailResult
      ref="ModalDetailResult"
      @refresh="handleRefresh"
    />
  </el-drawer>
</template>

<script>
import appUtils from '../../../../utils/appUtils'
import moment from 'moment'
import uploadIndicationFile from '../../../../utils/uploadIndicationFile'
import dataDemo from './ModalIndication/dataMemo'
import IndicationComments from '@/components/Indications/IndicationComments.vue'
import JsBarcode from 'jsbarcode'
import _ from 'lodash'
import { mapState } from 'vuex'
import ModalDetailResult from './DetailResult.vue'

export default {
  name: 'ModalDetailIndication',
  components: { IndicationComments, ModalDetailResult },
  data () {
    return {
      sending: false,
      dialogVisible: false,
      resulting: false,
      loading: false,
      show_highlight_result: false,
      indication: null,
      mr_master: null,
      formConclusion: {
        conclusion: ''
      },
      formLink: null,
      isEditConclusion: false,
      isEditLink: false,
      links: [],
      conclusions: [],
      files: [],
      messageText: '',
      uploadIndicationFile,
      indicationId: null,
      dataDemo,
      valueStatus: '',
      options: [{
        value: 1,
        label: 'Chưa nhận xét'
      }, {
        value: 2,
        label: 'Clinical Signification'
      }, {
        value: 3,
        label: 'Non Clinical Signification'
      }],
      selected_docs: [],
      nameFiles: []
    }
  },
  watch: {
    indication (value) {
      this.resulting = value?.status || value?.examination_results || false
      if (this.person?.medical_record_code) {
        try {
          setTimeout(() => {
            JsBarcode('#barcode', this.person.medical_record_code, {
              fontSize: 30
            })
          }, 200)
        } catch (error) {
          console.log(error)
        }
      }
    },
    '$refresh' () {
      if (this.indicationId) this.getIndication(this.indicationId)
    }
  },
  computed: {
    ...mapState({
      person: state => state.person
    }),
    isResult () {
      return this.indication?.status === 2 || this.indication?.status === 3
    }
  },
  methods: {
    async sendIndicationToPatient () {
      if (!this.person || !this.indication) return
      if (!this.person.phone) {
        alert('Gửi thất bại! Thông tin bệnh nhân không có số điện thoại!')
        return
      }
      let params = {
        indication_id: this.indication?.id,
        phone_number: this.person.phone
      }
      this.sending = true
      await this.$rf.getRequest('DoctorRequest').sendIndicationToPatient(params).then(() => {
        this.$toast.open({
          message: 'Đã gửi thành công',
          type: 'success'
        })
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.sending = false
      })
    },
    getGender () {
      return appUtils.getGender(this.person?.gender)
    },
    handleRefresh () {
      this.getIndication(this.indicationId)
      this.$emit('refresh')
    },
    viewDetailResult () {
      console.log('this.indication', this.indication?.examination_results?.id)
      this.$refs.ModalDetailResult.openDialog(this.indicationId, this.indication?.examination_results?.id)
    },
    async onSubmitFiles (docs) {
      uploadIndicationFile.indicationUploadHanlder(this.indicationId, docs, 1, null, this.nameFiles)
      // setTimeout(() => {
      //   if (!this.indication.status) this.$emit('refresh')
      // }, 1000)
    },
    async createLink (id, options) {
      await this.$rf.getRequest('DoctorRequest').createIndicationAttach(id, options).then((r) => {
        this.$emit('refresh')
        this.getIndication(this.indicationId)
        this.closeAddLink()
        return r.data
      }).catch((error) => {
        console.log('error', error)
      })
    },
    async getIndication (id) {
      this.loading = true
      await this.$rf.getRequest('DoctorRequest').getIndicationById(id)
        .then(res => {
          this.indication = res.data
          this.mr_master = res.data?.indication_order?.medical_record?.medical_record_master
          this.conclusions = this.sortByDate(this.indication.conclusions)
          this.files = this.indication.files?.filter((f => !f.examination_result_id)) || []
          this.links = this.indication.links?.filter((f => !f.examination_result_id)) || []

          this.setStatusDefault(this.indication)
        })
        .catch(error => {
          console.log('getIndication', error)
        }).finally(() => {
          this.loading = false
        })
    },
    async createConclusion (param) {
      const params = {
        indication_id: this.indicationId,
        ...param
      }
      await this.$rf.getRequest('DoctorRequest').createIndicationConclusions(params)
        .then(res => {
          this.$emit('refresh')
          this.getIndication(this.indicationId)
          this.formConclusion = null
          this.isEditConclusion = false
        })
        .catch(error => {
          console.log('createConclusion', error)
        })
    },
    openDialog (id) {
      this.dialogVisible = true
      this.indicationId = id
      this.getIndication(this.indicationId)
    },
    handleClose () {
      this.dialogVisible = false
      this.valueStatus = ''
    },
    formatDMY (date) {
      return date && moment(date).format('HH:mm DD-MM-YYYY')
    },
    formatDate (date) {
      return date && moment(date).format('DD-MM-YYYY')
    },
    uploadDocs () {
      this.$refs.inputFile.click()
      this.$refs.inputFile.value = null
    },
    modalUploadFile (show) {
      window.$('#modalUploadFile').modal(show ? 'show' : 'hide')
    },
    deleteSltDoct (i) {
      this.selected_docs.splice(i, 1)
      this.nameFiles.splice(i, 1)
    },
    onSelectedFile (e) {
      const files = e.target.files
      if (files) {
        for (let i = 0; i < files.length; i++) {
          this.nameFiles.push({
            description: files[i].name
          })
          this.selected_docs.push(files[i])
          console.log('this.nameFiles[i]', this.nameFiles[i])
        }
      }
    },
    onUpload () {
      if (!this.selected_docs || !this.selected_docs.length) {
        alert('Vui lòng chọn tài liệu')
        return
      }
      this.onSubmitFiles(this.selected_docs)
      this.selected_docs = []
      this.modalUploadFile(false)
    },
    getImageURL (avatar) {
      return appUtils.getImageURL(avatar)
    },
    addConclusion () {
      this.formConclusion = {
        conclusion: ''
      }
      this.isEditConclusion = false
    },
    deleteConclusion (index) {
      // this.conclusions.splice(index, 1)
    },
    addLink () {
      this.formLink = {
        name: '',
        url: '',
        type: 2
      }
      this.isEditLink = false
    },
    deleteLink (id, index) {
      if (!confirm('Bạn có chắc chắn thực hiện thao tác này?')) return
      this.links.splice(index, 1)
      this.deleteIndicationAttach(id)
    },
    deleteFile (id, index) {
      if (!confirm('Bạn có chắc chắn thực hiện thao tác này?')) return
      this.files.splice(index, 1)
      this.deleteIndicationAttach(id)
    },
    closeAddLink () {
      this.formLink = null
      this.isEditLink = false
    },
    submitLink () {
      if (!this.formLink.name || !this.formLink.url) {
        alert('Vui lòng nhập đủ thông tin')
        return
      }
      if (this.isEditLink) {
        // this.deleteLink(this.formLink.index)
      }
      this.createLink(this.indicationId, this.formLink)
    },
    submitConclusion () {
      if (!this.formConclusion.conclusion) {
        alert('Vui lòng nhập đủ thông tin')
        return
      }
      if (this.isEditConclusion) {
        this.deleteConclusion(this.formConclusion.index)
      }
      this.createConclusion(this.formConclusion)
    },
    openLink (link) {
      link.url && window.open(link.url)
    },
    async downloadFile (name) {
      if (!name) return
      const self = this
      const params = {
        fileName: name
      }
      const header = {
        'x-api-key': '4be5160e89e681cede9a80ae6db6af7c'
      }
      await self.$rf.getRequest('AuthRequest').getLinkDownloadAwsRc(params, header, false).then((r) => {
        if (r?.data?.data) window.open(r.data.data)
      }).catch((e) => {
        self.$toast.open({
          message: 'File không tồn tại hoặc gặp lỗi trong quá trình tải xuống',
          type: 'warning'
        })
        console.error(e)
      })
    },
    getDataDemo (id) {
      return id ? this.dataDemo[id - 1].name : ''
    },
    setValueStatus (option) {
      if (!option?.value) return
      if (confirm('Bạn chắc chắn muốn đổi trạng thái.')) this.updateStatusIndication(option?.value)
    },
    async updateStatusIndication (status) {
      const params = {
        status
      }
      await this.$rf.getRequest('DoctorRequest').updateStatusIndication(this.indicationId, params)
        .then(res => {
          this.setStatusDefault(res.data)
          this.$emit('refresh')
          this.$message({
            message: 'Thay đổi trạng thái thành công',
            type: 'success'
          })
        })
        .catch(error => {
          console.log('updateStatusIndication', error)
          this.$message({
            message: 'Thay đổi trạng thái thất bại',
            type: 'error'
          })
        })
    },
    async deleteIndicationAttach (id) {
      if (!id) return
      await this.$rf.getRequest('DoctorRequest').deleteIndicationAttach(id)
        .then(res => {
          console.log('deleteIndicationAttach', res)
          this.$message({
            message: 'Xóa thành công',
            type: 'success'
          })
        })
        .catch(error => {
          console.log('deleteIndicationAttach', error)
          this.$message({
            message: 'Xóa thất bại',
            type: 'error'
          })
        })
    },
    setStatusDefault (obj) {
      if (obj?.status === 2) this.valueStatus = this.options[1].label
      else if (obj?.status === 3) this.valueStatus = this.options[2].label
      else this.valueStatus = this.options[0].label
    },
    sortByDate (data) {
      return _.orderBy(
        data,
        ['updated_at'],
        ['desc']
      )
    },
    changeResulting () {
      this.show_highlight_result = true
      this.resulting = true
      setTimeout(() => {
        this.show_highlight_result = false
      }, 10000)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-drawer__header {
    align-items: center;
    color: #72767b;
    display: flex;
    margin-bottom: 0;
    padding: 10px 20px 0;
  }
  .input-container {
    border: 1px solid #939393;
    border-radius: 4px;
    color: #939393;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    border: none;
  }
  .el-button.btn-icon {
    border: none;
    font-size: 20px;
    padding: 8px 10px;
  }
  .el-button.btn-dropdown {
    min-width: 200px;
    padding: 8px 10px;
  }
  .row {
    margin: 0;
  }
  .wrap {
    word-wrap: break-word;
  }
  .height-60 {
    height: 60px;
  }
  .box-shadow-h {
    box-shadow: 0px 0px 20px rgba(25, 78, 255, 0.3);
  }
  .upload-btn {
    width: 100%;
    border: 1px dashed #20419b;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    border-radius: 9px;
    cursor: pointer;
  }
  .upload-btn2 {
    padding: 18px 0px 18px 0px;
  }
  .w-265px {
    width: 100%;
    max-width: 265px;
  }
}
</style>